import api from '../api'

const baseUrl = '/academy/api/RedirectUrl'

const dadbanRedirectProvider = {
  getAllRedirects() {
    return api.get(`${baseUrl}/GetAll`)
  },

  addRedirect(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  deleteRedirect(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },
}

export default dadbanRedirectProvider
